module.exports = __webpack_public_path__ + "static/img/7.134408b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/sp/7.png
// module id = 02RV
// module chunks = 0